import * as React from 'react';

import SvgIcon, { SvgIconProps } from './SvgIcon';

const IcMedia: React.SFC<SvgIconProps> = ({ children, ...rest }) => {
  /* tslint:disable:max-line-length */
  return (
    <SvgIcon viewBox="0 0 24 24" {...rest}>
      <path d="M23,0H1C0.448,0,0,0.448,0,1v22c0,0.552,0.448,1,1,1h22c0.552,0,1-0.448,1-1V1C24,0.448,23.552,0,23,0z M22,22H2V2h20V22z" />
      <path
        data-color="color-2"
        d="M5,20h14c0.364,0,0.698-0.197,0.875-0.515s0.166-0.707-0.026-1.015l-5-8 c-0.156-0.25-0.415-0.418-0.706-0.46c-0.291-0.043-0.586,0.047-0.807,0.242l-9,8c-0.31,0.276-0.417,0.715-0.27,1.103S4.585,20,5,20z "
      />
      <circle data-color="color-2" cx="7" cy="7" r="2" />
    </SvgIcon>
  );
};

export default IcMedia;



// WEBPACK FOOTER //
// ./src/common/components/svg/IcMedia.tsx